// extracted by extract-css-chunks-webpack-plugin
module.exports = {"postColumn":"gear-view__postColumn__30LWJ"};